import { makeGetRequest } from 'lib/axios';

type SchoolListResponse = {
  message: string;
  payload: string[];
};

/**
 * Schools stored in Mongo (`schools-list` collection).
 * Public: `GET /scla/schools-list/getSchools`
 */
const getSchoolList = async (): Promise<string[]> => {
  const response = await makeGetRequest<SchoolListResponse>(
    '/scla/schools-list/getSchools',
  );
  const { payload } = response.data;
  if (!Array.isArray(payload)) return [];
  return payload.filter(
    (name): name is string => typeof name === 'string' && name.trim().length > 0,
  );
};

export default getSchoolList;
